interface Option {
  whitelist: string[];
  blacklist: string[];
  [prop: string]: any;
}

export const getOptionFromList = (options: Option[], answers: string[]) => {
  let typeOptionIndex = options?.findIndex(opt => {
    const passedWhitelist = opt.whitelist.some((w: string) =>
      answers.some(a => a === w),
    );
    const passedBlacklist = opt.blacklist.some((w: string) =>
      answers.some(a => a === w),
    );
    return passedWhitelist && !passedBlacklist;
  });

  if (typeOptionIndex === -1) {
    typeOptionIndex = options.length - 1;
  }
  return options?.[typeOptionIndex];
};

export const formatCost = (num: number) => {
  const localeString = (Math.round(num * 100) / 100).toLocaleString('en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
  return localeString.replace(',', ' ').replace('.', ',');
};

export const getUnixDate = () => Math.floor(new Date().getTime() / 1000);

export const leadLanguage = (param: string) => {
  if (param.includes('_es')) return 'es';
  if (param.includes('_de')) return 'de';
  if (param.includes('_fr')) return 'fr';
  if (param.includes('_it')) return 'it';
  return 'en';
};
